import { useState } from 'react';
import TroubleshootingLayout from './components/troubleshooting-layout/troubleshooting-layout';
import ActionRouter from './components/action-router/action-router';
import { MainAction } from './types/action-types';

interface ITroubleshootingPageProps {}

const TroubleshootingPage: React.FC<ITroubleshootingPageProps> = () => {
    const [selectedMainAction, setSelectedMainAction] = useState<MainAction>(MainAction.COMMON_ACTIONS);

    return (
        <TroubleshootingLayout
            selectedMainAction={selectedMainAction}
            onMainActionChange={setSelectedMainAction}
        >
            <ActionRouter selectedMainAction={selectedMainAction} />
        </TroubleshootingLayout>
    );
};

export default TroubleshootingPage;
